
import React from 'react';

const WhyChooseUs: React.FC = () => {
  const reasons = [
    {
      title: 'Expert Technicians',
      description: 'Our residential support team has years of experience solving complex IT issues for businesses, bringing that same level of expertise to your home.'
    },
    {
      title: 'Jargon-Free Explanations',
      description: 'We explain technology in plain English, helping you understand the issues and solutions without confusing technical terms.'
    },
    {
      title: 'Fast Response Times',
      description: 'Technology problems are frustrating and disruptive. We prioritize quick response times to get your home technology back up and running.'
    },
    {
      title: 'Remote & On-Site Options',
      description: 'Many issues can be resolved quickly via remote support, but we also offer convenient on-site visits when hands-on attention is needed.'
    },
    {
      title: 'Preventative Approach',
      description: 'We don\'t just fix problems—we help prevent them with regular maintenance, updates, and security checks to keep your technology running smoothly.'
    },
    {
      title: 'Satisfaction Guarantee',
      description: 'We stand behind our work with a satisfaction guarantee. If you\'re not happy with our service, we\'ll make it right.'
    }
  ];

  return (
    <section className="section-padding bg-white">
      <div className="container-wide">
        <div className="text-center mb-12">
          <h2 className="heading-lg text-itmgmt-dark-blue mb-4">Why Choose Our Residential IT Services</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We bring enterprise-level expertise to your home with friendly, reliable service.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-itmgmt-dark-blue mb-3">{reason.title}</h3>
              <p className="text-gray-600">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
